export default __webpack_public_path__ + "static/media/icon_policy_overview_bottom1.ada19dc2.svg";